document.addEventListener('DOMContentLoaded', () => {
    const offersButton = document.querySelector('.offers-context-wrapper');
    const overlay = document.querySelector('.js-slideout-overlay');

    if (!offersButton) return;

    document.body.classList.add('offers-available');

    let isOffersShown = false;
    const inactivityTime = 60000;
    let activityTimeout;

    // Toggle offers
    const toggleOffers = (event) => {
        offersButton.classList.toggle('active');
        document.body.classList.toggle('offers-open', offersButton.classList.contains('active'));
        isOffersShown = true;
        if (event) event.stopPropagation();
    };

    // Function to mark user as inactive
    const userInactive = () => {
        if (!isOffersShown) toggleOffers();
    };

    // Function to reset the inactivity timer
    const resetInactivityTimer = () => {
        clearTimeout(activityTimeout);
        if (!isOffersShown) {
            activityTimeout = setTimeout(userInactive, inactivityTime);
        }
    };

    // Add event listeners for user activity
    ['mousemove', 'keydown', 'scroll', 'click'].forEach(eventType => {
        window.addEventListener(eventType, resetInactivityTimer);
    });

    // Start the inactivity timer on page load
    resetInactivityTimer();

    // Toggle offers when the button is clicked
    offersButton.addEventListener('click', toggleOffers);

    // Close offers when clicking outside the offersButton
    document.addEventListener('click', (event) => {
        if (!offersButton.contains(event.target)) {
            offersButton.classList.remove('active');
            document.body.classList.remove('offers-open');
        }
    });

    // Close offers when clicking on the overlay
    if (overlay) {
        overlay.addEventListener('click', () => {
            offersButton.classList.remove('active');
            document.body.classList.remove('offers-open');
        });
    }
});
